"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSemver = void 0;
/**
 * Splits semver version string into components
 *
 *
 * Reference: https://ihateregex.io/expr/semver/
 *
 * Non standard options:
 * - Ignores starting 'v' i.e. accepts v1.2.3
 * - minor and patch as optional
 *
 * @param version Semver formatted version
 */
function parseSemver(version) {
    const regex = 
    // eslint-disable-next-line max-len
    /^v?(0|[1-9]\d*)(?:\.(0|[1-9]\d*)(?:\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][\da-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][\da-zA-Z-]*))*))?(?:\+([\da-zA-Z-]+(?:\.[\da-zA-Z-]+)*))?)?)?$/;
    const match = version.match(regex);
    if (match) {
        return [
            Number(match[1]),
            match[2] ? Number(match[2]) : undefined,
            match[3] ? Number(match[3]) : undefined,
            match[4],
            match[5],
        ];
    }
    return undefined;
}
exports.parseSemver = parseSemver;
//# sourceMappingURL=sem-ver.js.map